import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'ui/i18n';
import { observer } from 'mobx-react';
import { computed } from 'mobx';
import { render_date } from 'utils';
import { toMoment } from 'api/helpers';
import { findInArray } from 'utils/helpers';

import './EstShipDate.scss';

@observer
export default class EstShipDate extends Component {
	static propTypes = {
		item: PropTypes.object.isRequired,
	};

	hasDifferentShipDate = false;

	@computed
	get estShipDateList() {
		const shipDateList = [];
		this.hasDifferentShipDate = false;

		if (this.props.item.is_pack) {
			const packItems = this.props.item.offerings;
			const fullEstShipList = [];

			packItems.forEach((item, index) => {
				if (index !== 0 && !fullEstShipList.includes(item.est_ship_date._i)) {
					this.hasDifferentShipDate = true;
				}
				if (!item.is_configurable) {
					shipDateList.push(item.est_ship_date._i);
				}

				fullEstShipList.push(item.est_ship_date._i);
			});

			if (this.props.item.configurations) {
				this.props.item.configurations.forEach(config => {
					const itemFromOfferings = findInArray(
						this.props.item.offerings,
						config.id,
						'id'
					);
					if (itemFromOfferings) {
						shipDateList.push(itemFromOfferings.est_ship_date._i);
					}
				});
			}
		}

		return shipDateList;
	}

	render() {
		const { item } = this.props;
		return (
			<div className="EstShipDate">
				<div className="EstShipDateContent">
					{this.props.item.is_pack &&
					this.estShipDateList.length > 0 &&
					this.hasDifferentShipDate
						? <div>
								{/* leave as is to offset data when we have choose color in the name col */}
								<span
									className={`noWrap ${item.is_configurable ? '' : 'no-space'}`}
								>
									<FormattedMessage id="item.See_Components" />
								</span>
								{/* we can't controll table rows so we made this to align item name with invoice weeks" */}
								<div className="invisible">
									{item.name}
								</div>
							</div>
						: ''}
					{this.props.item.is_pack &&
					this.estShipDateList.length > 0 &&
					this.hasDifferentShipDate
						? this.estShipDateList.map((shipDate, index) =>
								<div key={index} className={'EstShipDate-subsection'}>
									{render_date(toMoment(shipDate))}
								</div>
							)
						: render_date(item.est_ship_date_for_cart)}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/EstShipDate/index.js